var _circle, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWithdrawal = function SvgWithdrawal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16ZM13.375 9C13.375 9.29036 13.2336 9.54769 13.0158 9.70685C12.9845 9.74793 12.95 9.78741 12.9125 9.82496L10.4937 12.2437C10.152 12.5854 9.59798 12.5854 9.25627 12.2437C8.91456 11.902 8.91456 11.348 9.25627 11.0063L10.3876 9.875H5.5C5.01675 9.875 4.625 9.48325 4.625 9C4.625 8.51675 5.01675 8.125 5.5 8.125H10.3876L9.25627 6.99372C8.91457 6.65201 8.91456 6.09799 9.25627 5.75628C9.59798 5.41457 10.152 5.41457 10.4937 5.75628L12.9125 8.17504C12.95 8.21259 12.9845 8.25207 13.0158 8.29315C13.2336 8.45231 13.375 8.70964 13.375 9Z",
    fill: "#4678FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    stroke: "white",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWithdrawal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Withdrawal.0b47a68faaaf1f7eea79a1c796852117.svg";